import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import * as apiPostConfirmEmail from 'api/user/PostConfirmEmail';
import VerifyForm from 'components/desktop/User/Verify/VerifyForm';
import LogoAnimation from 'components/desktop/_general/LogoAnimation/LogoAnimation';
import { EAlertType } from 'enums/alertType';
import { fireAlert } from 'functions/fireAlert';
import getQueryParam from 'functions/getQueryParam';
import { logout } from 'functions/tokenFunctions';
import {
	UserVerificationDto,
	defaultUserVerificationDto,
} from 'types/User/Verification/UserVerificationDto';

const Verify = () => {
	const { t } = useTranslation();
	const [userId, setUserId] = useState('');
	const [verificationDto, setVerificationDto] = useState<UserVerificationDto>(
		defaultUserVerificationDto()
	);
	const navigate = useNavigate();

	useEffect(() => {
		const userId = getQueryParam('user');
		const verificationToken = getQueryParam('token');
		if (!userId || !verificationToken) {
			navigate('/login');
			return;
		}

		setUserId(userId);
		setVerificationDto((prev) => ({ ...prev, confirmationCode: verificationToken }));
	}, []);

	const showSuccessNotification = () => {
		fireAlert(
			EAlertType.success,
			t('alerts:ALERT_VALIDATION_GOOD'),
			t('alerts:ALERT_VALIDATION_GOOD_MESSAGE'),
			10000
		);
	};

	const showFailNotification = () => {
		fireAlert(
			EAlertType.danger,
			t('alerts:ALERT_VALIDATION_ERROR'),
			t('alerts:ALERT_VALIDATION_ERROR_MESSAGE'),
			10000
		);
	};

	const handleConfirm = () => {
		try {
			apiPostConfirmEmail.callApi(userId, verificationDto).then(async () => {
				showSuccessNotification();
				await logout();
				navigate('/login');
			});
		} catch (error) {
			console.error(error);
			showFailNotification();
		}
	};

	const renderContent = () => {
		return (
			<>
				<div className="credentials-background-gradient">
					<div className="credentials-white-bar" />
					<div className="credentials-container">
						<LogoAnimation />
						<div className="credentials-form">
							<h1 className="text-center">
								{t('_general:TITLE_EMAIL_CONFIRMATION')}
							</h1>
							<hr />
							<VerifyForm
								dto={verificationDto}
								setDto={setVerificationDto}
								confirm={handleConfirm}
							/>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default Verify;
